import constants from '@/constants'
export default {
  POWER_POINT_PROJECTIONS: [
    'name',
    'organization',
    'status',
    'createdAt',
    'updatedAt',
    'assignees',
    'siteAttributes',
    'validations',
    'collaborators',
    'countryCodes',
    'afterPhase',
    'beforePhase',
    'relate',
    'expand',
    'problemAnalysis',
    'solutionDescription',
    'categories',
    'impactStartsAt',
    'impactEndsAt',
    'createdBy',
    'tags',
    'coach',
    'author',
    'validatedReview',
    'site',
    'currencyMetadata',
    'lang',
    'solutionMedia',
    'owner',
    'image',
  ],
  POWER_POINT_EXPANSIONS: [
    'createdBy',
    'tags',
    'coach',
    'author',
    'assignees',
    'siteAttributes',
    'validations',
    'collaborators',
    'afterPhase',
    'beforePhase',
    'relate',
    'expand',
    'problemAnalysis',
    'solutionDescription',
    'categories',
    'validatedReview',
    'site',
    'currencyMetadata',
    'owner',
    'solutionMedia',
    'image',
  ],
  VIEW_STATES: {
    FILTERS: 'filters',
    LIST: 'list',
    DETAIL: 'detail',
    EMPTY: 'empty',
  },
  DEFAULT_POWER_POINT_FILTERS: {
    types: [
      constants.revTypes.improvementIdea,
      constants.revTypes.quickAction,
      constants.revTypes.problemSolving,
    ],
    status: [],
    assignees: [],
    categories: [],
    createdAt: null,
    createdAtOption: null,
    dueDate: [],
    dueDateOption: null,
    sites: [],
    siteGroups: [],
    tags: [],
    tagGroups: [],
    countryCodes: [],
    hasFinancialValidation: null,
    hasImplementationValidation: null,
  },
}
